import { Component, Input, forwardRef, OnChanges, SimpleChanges } from '@angular/core';

import { AbstractFormFieldComponent } from '../../FormField/abstract-form-field.component';
import { ColorCheckboxesFieldModel } from '../../../models/color-checkboxes-field.model';
import { defaultSeriesColorConfig } from '../../../../Charts/config/default-series-color.config';
import { ChartDisplayElementModel } from '../../../../Reports/models/chart-display-element.model';

// frequently, collections of checkbox options come with an associated color which you can pick
// this component does that job by putting a color swatch below every checkbox
@Component({
    selector: 'agpr-color-picker-by-count-field',
    templateUrl: './color-picker-by-count-field.component.html',
    styleUrls: ['./color-picker-by-count-field.component.scss'],
    providers: [
        {
            provide: AbstractFormFieldComponent,
            useExisting: forwardRef(() => ColorPickerByCountFieldComponent)
        }
    ],
    standalone: false
})
export class ColorPickerByCountFieldComponent extends AbstractFormFieldComponent implements OnChanges {
    @Input() declare field: ColorCheckboxesFieldModel;

    readonly defaultColors: string[] = defaultSeriesColorConfig.slice();

    ngOnChanges(changes: SimpleChanges) {
        if (changes?.value?.previousValue === changes?.value?.currentValue) {
            return;
        }

        if (!this.value?.length) {
            return;
        }

        this.setDefaultValues();
    }

    setDefaultValues() {
        if (this.value?.length) {
            this.value.forEach((series, index) => {
                if (!series.color) {
                    series.color = this.defaultColors[index];
                }
            });
            this.handleChanges();
        }
    }

    handleChanges(): void {
        const displayElement = this.block?.displayElement as ChartDisplayElementModel;
        this.value.forEach((series, i) => {
            if (series.color && displayElement) {
                const key = `seriesColor${i}`;
                displayElement.styles.colorMap[key] = series.color;
            }
        });
        this.changes.emit(this.value);
    }

    handleColorChange(colorHexString: string, index: number): void {
        if (this.value && this.value[index]) {
            this.value[index].color = colorHexString;
        }
        this.handleChanges();
    }
}
